import { useState, useEffect, useCallback } from 'react';
import { createPortal } from 'react-dom';
import { EditButton, DeleteButton } from '../../components/ActionButtons';
import { apiRequest } from '../../services/api';
import UsageInfo from '../../components/UsageInfo';
import LoadingSpinner from '../../components/LoadingSpinner';
import EmptyState from '../../components/EmptyState';
import PageHeader from '../../components/PageHeader';
import ModalShell from '../../components/ModalShell';

function FormHata({ mesaj }) {
  if (!mesaj) return null;
  return <p className="text-[10px] font-black text-rose-500 uppercase tracking-widest mt-2 flex items-center gap-1 animate-shake">⚠️ {mesaj}</p>;
}

function OdaGrubuModal({ grup, onKapat, onKaydedildi }) {
  const yeni = !grup?.odaGrubuId;
  const [form, setForm] = useState({
    grupNo: grup?.grupNo || '',
    grupAdi: grup?.grupAdi || '',
    aktifMi: grup?.aktifMi ?? true,
  });
  const [kaydediliyor, setKaydediliyor] = useState(false);
  const [hatalar, setHatalar] = useState({});

  const INP = (hata) =>
    `w-full border-2 rounded-2xl px-5 py-3.5 text-sm font-bold text-gray-800 transition-[border-color,box-shadow,background-color] duration-200 bg-white focus:outline-none ${
      hata ? 'border-rose-400 bg-rose-50 focus:border-rose-500 shadow-rose-50 shadow-inner' : 'border-gray-100 focus:border-indigo-400 focus:ring-4 focus:ring-indigo-50 shadow-sm'
    }`;

  const toTitleCase = (str) => {
    return str.toLocaleLowerCase('tr-TR').split(' ').map(word => 
      word.charAt(0).toLocaleUpperCase('tr-TR') + word.slice(1)
    ).join(' ');
  };

  async function handleKaydet() {
    const h = {};
    if (!form.grupAdi.trim()) h.grupAdi = 'Grup Adı zorunludur.';
    if (!form.grupNo) h.grupNo = 'Grup No zorunludur.';
    if (Object.keys(h).length > 0) { setHatalar(h); return; }

    setKaydediliyor(true); setHatalar({});
    try {
      const formattedGrupAdi = toTitleCase(form.grupAdi.trim());
      const payload = { grupNo: parseInt(form.grupNo), grupAdi: formattedGrupAdi, aktifMi: form.aktifMi };
      if (yeni) await apiRequest('OdaGrubu', 'POST', payload);
      else await apiRequest(`OdaGrubu/${grup.odaGrubuId}`, 'PUT', { ...payload, odaGrubuId: grup.odaGrubuId });
      onKaydedildi(); onKapat();
    } catch { setHatalar({ genel: 'Kayıt sırasında hata oluştu.' }); }
    setKaydediliyor(false);
  }

  return (
    <ModalShell
      icon={yeni ? '➕' : '✏️'}
      iconColor="from-indigo-600 to-violet-700"
      title={yeni ? 'Yeni Kat / Grup' : 'Grup Düzenle'}
      subtitle="Odaları organize etmek için fiziksel gruplar"
      onClose={onKapat}
      size="md"
      footer={
        <>
          <button onClick={onKapat} className="px-8 py-3.5 rounded-2xl border-2 border-gray-100 text-xs font-black text-gray-400 hover:bg-gray-100 transition-all uppercase tracking-widest active:scale-95">İPTAL</button>
          <button onClick={handleKaydet} disabled={kaydediliyor}
            className="px-10 py-3.5 bg-gradient-to-r from-indigo-500 to-violet-700 hover:from-indigo-600 hover:to-violet-800 disabled:opacity-60 text-white rounded-2xl text-xs font-black shadow-xl shadow-indigo-200 transition-all hover:-translate-y-1 active:translate-y-0 tracking-widest uppercase">
            {kaydediliyor ? '⌛ KAYDEDİLİYOR...' : yeni ? '💾 GRUBU KAYDET' : '💾 GÜNCELLE'}
          </button>
        </>
      }
    >
          {hatalar.genel && <div className="bg-rose-50 border-2 border-rose-100 rounded-2xl px-5 py-4 text-xs text-rose-600 font-black uppercase tracking-widest leading-none animate-shake">⚠️ {hatalar.genel}</div>}

          <div>
            <label className="text-[10px] font-black text-gray-400 uppercase tracking-[0.2em] block mb-3 ml-1">GRUP / KAT SIRASI *</label>
            <div className="relative">
              <input type="number" value={form.grupNo} onChange={e => setForm(p => ({ ...p, grupNo: e.target.value }))}
                className={INP(hatalar.grupNo) + ' text-center h-[54px] shadow-inner font-black text-lg pr-12'} placeholder="ÖRN: 1, 2, 3" autoFocus />
              <FormHata mesaj={hatalar.grupNo} />
            </div>
            <p className="text-[9px] font-bold text-indigo-400 mt-3 uppercase tracking-[0.15em] border-l-4 border-indigo-100 pl-4 bg-indigo-50/30 py-2 rounded-r-xl leading-relaxed">BU SIRA ODA PLANINDAKİ ARA YÜZ SIRALAMASINI BELİRLER.</p>
          </div>

          <div>
            <label className="text-[10px] font-black text-gray-400 uppercase tracking-[0.2em] block mb-3 ml-1">GRUP / KAT ADI *</label>
            <input value={form.grupAdi} onChange={e => setForm(p => ({ ...p, grupAdi: toTitleCase(e.target.value) }))}
              className={INP(hatalar.grupAdi)} placeholder="ÖRN: 1. Kat, Bungalovlar, A Blok" />
            <FormHata mesaj={hatalar.grupAdi} />
          </div>

          <div className="pt-4">
             <label className="flex items-center justify-between bg-gray-50/50 p-4 rounded-2xl border-2 border-gray-100 shadow-inner group select-none cursor-pointer">
                <span className={`text-[10px] font-black uppercase tracking-widest transition-colors duration-300 ${form.aktifMi ? 'text-indigo-600' : 'text-gray-400'}`}>GRUBU AKTİF OLARAK KULLAN</span>
                <div className="relative leading-none">
                  <input type="checkbox" checked={form.aktifMi} onChange={e => setForm(p => ({ ...p, aktifMi: e.target.checked }))} className="sr-only peer" />
                  <div className="w-12 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-6 peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-indigo-600 shadow-sm transform-gpu"></div>
                </div>
             </label>
          </div>
    </ModalShell>
  );
}

export default function OdaGruplari() {
  const [gruplar, setGruplar] = useState([]);
  const [yukleniyor, setYukleniyor] = useState(true);
  const [hata, setHata] = useState('');
  const [modal, setModal] = useState(null);
  const [silOnay, setSilOnay] = useState(null);
  const [siliniyor, setSiliniyor] = useState(false);
  const [araGrup, setAraGrup] = useState('');

  const fetchAll = useCallback(async () => {
    setYukleniyor(true); setHata('');
    try {
      const data = await apiRequest('OdaGrubu');
      setGruplar((data || []).sort((a, b) => a.grupNo - b.grupNo));
    } catch { setHata('Veriler yüklenemedi.'); }
    setYukleniyor(false);
  }, []);

  useEffect(() => { fetchAll(); }, [fetchAll]);

  async function handleSil(id) {
    setSiliniyor(true);
    try {
      await apiRequest(`OdaGrubu/${id}`, 'DELETE');
      setGruplar(p => p.filter(g => g.odaGrubuId !== id));
      setSilOnay(null);
    } catch { alert('Silme işlemi başarısız. Bu gruba bağlı odalar olabilir.'); }
    setSiliniyor(false);
  }

  const filtreli = gruplar.filter(g => !araGrup || g.grupAdi?.toLocaleLowerCase('tr-TR').includes(araGrup.toLocaleLowerCase('tr-TR')));

  return (
    <div className="p-3 md:p-6 space-y-7 min-h-screen bg-gray-50/50 animate-fadeIn" style={{ transform: 'translateZ(0)' }}>
      <PageHeader
        icon="🏢"
        iconColor="from-indigo-500 to-violet-700"
        iconShadow="shadow-indigo-200"
        title="Kat / Grup Tanımları"
        subtitle="Odaları organize etmek için fiziksel veya mantıksal gruplar"
      >
        <button onClick={() => setModal({})}
          className="group flex-shrink-0 flex items-center justify-center gap-3 bg-gradient-to-r from-indigo-600 to-violet-700 hover:from-indigo-700 hover:to-violet-800 text-white px-10 py-4 rounded-2xl text-[10px] font-black shadow-2xl shadow-indigo-100 transition-[background-color,transform] duration-300 hover:-translate-y-1 active:translate-y-0 uppercase tracking-widest relative overflow-hidden">
          <span className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300"></span>
          <span className="relative text-xl transition-transform group-hover:rotate-90">＋</span>
          <span className="relative">YENİ GRUP EKLE</span>
        </button>
      </PageHeader>

      <div className="grid grid-cols-2 lg:grid-cols-3 gap-4">
        {[
          { label: 'TOPLAM GRUP', value: gruplar.length, icon: '🏢', color: 'from-gray-700 to-gray-900 shadow-gray-200' },
          { label: 'AKTİF GRUPLAR', value: gruplar.filter(g => g.aktifMi).length, icon: '✅', color: 'from-indigo-500 to-indigo-700 shadow-indigo-100' },
          { label: 'PASİF GRUPLAR', value: gruplar.filter(g => !g.aktifMi).length, icon: '⏸️', color: 'from-rose-500 to-rose-700 shadow-rose-100' },
        ].map(k => (
          <div key={k.label} className={`relative overflow-hidden bg-gradient-to-br ${k.color} rounded-[2rem] p-6 text-white shadow-xl hover:shadow-2xl transition-[box-shadow,transform] duration-300 group`}>
             <div className="absolute -right-4 -bottom-4 text-7xl opacity-10 pointer-events-none group-hover:scale-125 transition-transform duration-500 transform-gpu">{k.icon}</div>
             <p className="text-[10px] font-black uppercase tracking-widest opacity-70 mb-1 leading-none">{k.label}</p>
             <p className="text-2xl font-black tracking-tight leading-none">{k.value}</p>
          </div>
        ))}
      </div>

      {hata && (
        <div className="bg-rose-50 border-2 border-rose-100 text-rose-600 px-8 py-5 rounded-[2rem] flex flex-col sm:flex-row items-center justify-between gap-4 shadow-xl shadow-rose-50 animate-shake leading-none">
          <span className="text-[11px] font-black uppercase tracking-widest">⚠️ {hata}</span>
          <button onClick={fetchAll} className="w-full sm:w-auto bg-white px-8 py-3 rounded-xl text-[10px] font-black shadow-sm hover:bg-rose-500 hover:text-white transition-all uppercase tracking-widest">TEKRAR DENE</button>
        </div>
      )}

      <div className="bg-white rounded-[2.5rem] border border-gray-200 shadow-sm overflow-hidden min-h-[400px]">
        <div className="px-6 md:px-8 py-5 border-b border-gray-100 bg-gray-50/30 flex flex-col md:flex-row items-center gap-6">
          <div className="relative flex-1 w-full text-left">
            <span className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 font-black">🔍</span>
            <input value={araGrup} onChange={e => setAraGrup(e.target.value)} placeholder="Grup adıyla filtrele..."
              className="w-full pl-11 pr-4 py-3.5 text-sm border-2 border-gray-100 rounded-2xl focus:border-indigo-400 focus:outline-none bg-white shadow-sm transition-all font-bold" />
          </div>
          <p className="text-[10px] font-black text-gray-400 uppercase tracking-widest ml-auto whitespace-nowrap">Sistemde toplam <b className="text-indigo-600 text-xs">{gruplar.length}</b> kayıt tanımlı</p>
        </div>

        <div className="divide-y divide-gray-50 leading-none">
          {yukleniyor ? (
            <LoadingSpinner fullPage text="Veriler Çekiliyor..." />
          ) : filtreli.length === 0 ? (
            <EmptyState icon="🏢" text="Eşleşen grup bulunamadı" />
          ) : filtreli.map((g, i) => (
            <div key={g.odaGrubuId} className={`group flex flex-col md:flex-row md:items-center justify-between p-6 md:p-8 hover:bg-indigo-50/20 transition-all duration-300 transform-gpu ${!g.aktifMi && 'opacity-60 grayscale bg-gray-100/50'}`}>
              <div className="flex items-center gap-6 mb-6 md:mb-0 text-left leading-none">
                <div className="flex flex-col items-center justify-center w-16 h-16 bg-white rounded-2xl shadow-xl shadow-indigo-50/50 border border-gray-100 group-hover:scale-110 group-hover:rotate-6 transition-all duration-500 transform-gpu">
                  <span className="text-[9px] font-black text-gray-300 uppercase tracking-tighter leading-none mb-1.5 opacity-60">KAT/RAFA</span>
                  <span className="text-2xl font-black text-indigo-600 leading-none">{g.grupNo}</span>
                </div>
                <div className="min-w-0">
                  <span className="block font-black text-gray-700 text-xl uppercase tracking-tight leading-none mb-3 truncate">{g.grupAdi}</span>
                  <div className="flex items-center gap-3">
                    <span className={`text-[9px] font-black px-3 py-1.5 rounded-lg border uppercase tracking-widest transition-colors shadow-sm ${g.aktifMi ? 'bg-emerald-50 text-emerald-600 border-emerald-100' : 'bg-gray-100 text-gray-400 border-gray-200'}`}>{g.aktifMi ? '✓ AKTİF' : '✗ PASİF'}</span>
                    <span className="text-[10px] font-black text-gray-400 uppercase tracking-widest opacity-70">🏠 {g.odaSayisi ?? 0} ODA TANIMLI</span>
                  </div>
                </div>
              </div>
              <div className="flex gap-2 justify-end">
                <EditButton size="lg" onClick={() => setModal(g)} />
                <DeleteButton size="lg" onClick={() => setSilOnay(g.odaGrubuId)} />
              </div>
            </div>
          ))}
        </div>
      </div>

      <UsageInfo
        color="rose"
        description="Kat / Grup tanımları, tesisinizdeki odaları fiziksel (Örn: 1. Kat, Bungalovlar) veya operasyonel olarak gruplamak için kullanılır."
        scenarios={[
          { title: "Dashboard Filtrelemesi", content: "Room Rack (Oda Panosu) ekranında sadece belirli bir kata veya gruba ait odaları görüntülemek için bu tanımları kullanabilirsiniz." },
          { title: "Sıralama Yönetimi", content: "Burada belirlediğiniz 'Grup Sırası', panolardaki odaların vizyon sıralamasını doğrudan etkiler." }
        ]}
      />

      {modal !== null && createPortal(
        <OdaGrubuModal grup={modal?.odaGrubuId ? modal : null} onKapat={() => setModal(null)} onKaydedildi={fetchAll} />,
        document.body
      )}

      {silOnay && createPortal(
        <div className="fixed inset-0 bg-black/60 z-[100] flex items-center justify-center px-4 backdrop-blur-md animate-fade-in shadow-2xl leading-none">
          <div className="bg-white rounded-[2.5rem] shadow-2xl p-10 w-full max-w-sm text-center border border-gray-100">
            <div className="w-24 h-24 bg-rose-50 rounded-[2.5rem] flex items-center justify-center mx-auto mb-6 text-5xl shadow-xl shadow-rose-100/50 animate-bounce-subtle leading-none">🗑️</div>
            <h3 className="font-black text-gray-900 text-xl tracking-tight uppercase leading-none">Grubu Sil</h3>
            <p className="text-[11px] font-black text-gray-500 mt-5 mb-5 leading-relaxed uppercase tracking-tight text-center">Bu grubu silmek istediğinizden emin misiniz?</p>
            <p className="inline-block text-[9px] font-black text-rose-500 bg-rose-50 rounded-xl px-5 py-3 mb-10 tracking-widest uppercase border border-rose-100">⚠️ DİKKAT: GRUBA BAĞLI ODA VARSA İŞLEM GEÇERSİZ OLUR.</p>
            <div className="flex gap-4">
              <button onClick={() => setSilOnay(null)} className="flex-1 py-4 bg-gray-50 text-gray-600 rounded-2xl text-[10px] font-black hover:bg-gray-100 transition-all uppercase tracking-widest active:scale-95">İPTAL</button>
              <button onClick={() => handleSil(silOnay)} disabled={siliniyor} className="flex-1 py-4 bg-gradient-to-r from-rose-500 to-red-600 text-white rounded-2xl text-[10px] font-black shadow-xl shadow-rose-200 transition-all uppercase tracking-widest active:scale-95">
                {siliniyor ? '⌛' : 'EVET, SİL'}
              </button>
            </div>
          </div>
        </div>,
        document.body
      )}

      <style>{`
        @keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
        .animate-fadeIn { animation: fadeIn 0.4s ease-out forwards; }
        @keyframes scaleIn { from { opacity: 0; transform: scale(0.95); } to { opacity: 1; transform: scale(1); } }
        .animate-scale-in { animation: scaleIn 0.3s ease-out forwards; }
        @keyframes shake { 0%, 100% { transform: translateX(0); } 25% { transform: translateX(-5px); } 75% { transform: translateX(5px); } }
        .animate-shake { animation: shake 0.3s ease-in-out infinite; animation-iteration-count: 2; }
        @keyframes bounceSubtle { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(-10px); } }
        .animate-bounce-subtle { animation: bounceSubtle 2s infinite; }
        .no-scrollbar::-webkit-scrollbar { display: none; }
        .no-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
      `}</style>
    </div>
  );
}